export default __webpack_public_path__ + "static/olga-51d7b27d2f73a1d4ab6cc85f37731a24.jpeg";